import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=be17deba"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeartIcon: require('/vercel/path0/components/icons/HeartIcon.vue').default,PlusIcon: require('/vercel/path0/components/icons/PlusIcon.vue').default})
